import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const HOSPITAL_PATH = 'hospital'

export function getPageHospitals(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${HOSPITAL_PATH}/getPage`, filterRequest, {
            params: {
                userId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getListHospitals(userId, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${HOSPITAL_PATH}/getList`, filterRequest, {
            params: {
                userId,
                dto,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getSectionListHospital(userId, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${HOSPITAL_PATH}/getSectionListOptions`,
            filterRequest,
            {
                params: {
                    userId,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function createOrUpdateHospital(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${HOSPITAL_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getHospitalInfo(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${HOSPITAL_PATH}/getById`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
